<template>
  <div
    class="m-wrap-new m-pc"
    v-if="extras1.formBg"
    :style="{
      background:
        extras1.formBg.colorOrBg == 'color'
          ? extras1.formBg.color
          : 'url(' + extras1.formBg.src + ')',
    }"
  >
    <div class="semianr-logo" v-if="extras1 && extras1.formLogo.display == '1'">
      <img
        :src="
          isSetting != '1'
            ? extras1.headerLogo && extras1.headerLogo.src
            : './images/logo_new.png'
        "
        alt=""
      />
    </div>
    <div class="seminar-info" v-if="isSetting != '1'">
      <div
        class="seminar-info-new"
        v-if="extras1 && extras1.seminarInfo.display == '1'"
        :class="extras1.BannerText.textAlign"
      >
        <div class="content">
          <div
            class="seminar-title"
            v-if="extras1.textSetting.subTitle != 'hide'"
            :style="{
              color:
                extras1.textSetting.subTitle == 'custom'
                  ? extras1.textSetting.fontColor
                  : '',

              'font-style':
                extras1.textSetting.subTitle == 'custom'
                  ? extras1.textSetting.fontTilt == 'on'
                    ? 'italic'
                    : 'normal'
                  : '',
              'font-Weight':
                extras1.textSetting.subTitle == 'custom'
                  ? extras1.textSetting.fontWeight == 'on'
                    ? '900'
                    : ''
                  : '',
            }"
          >
            {{ extras1.textSetting.text }}
          </div>
          <div
            class="seminar-slogan"
            v-if="extras1.textSetting.title != 'hide'"
            :style="{
              color:
                extras1.textSetting.title == 'custom'
                  ? extras1.textSetting.fontColor2
                  : '',

              'font-style':
                extras1.textSetting.title == 'custom'
                  ? extras1.textSetting.fontTilt2 == 'on'
                    ? 'italic'
                    : 'normal'
                  : '',
              'font-Weight':
                extras1.textSetting.title == 'custom'
                  ? extras1.textSetting.fontWeight2 == 'on'
                    ? '900'
                    : ''
                  : '',
            }"
          >
            {{
              extras1.textSetting.title == "default"
                ? seminarInfo.title
                : seminarInfo.title
            }}
          </div>
          <div class="semianr-time">
            <div
              class="_title"
              v-show="extras1.textSetting.timeTitle != 'hide'"
              :style="{
                color:
                  extras1.textSetting.timeTitle == 'custom'
                    ? extras1.textSetting.fontColor3
                    : '',
                background: extras1.textSetting.bgColor5 || '',
                'font-style':
                  extras1.textSetting.timeTitle == 'custom'
                    ? extras1.textSetting.fontTilt3 == 'on'
                      ? 'italic'
                      : 'normal'
                    : '',
                'font-Weight':
                  extras1.textSetting.timeTitle == 'custom'
                    ? extras1.textSetting.fontWeight3 == 'on'
                      ? 'bolder'
                      : ''
                    : '',
              }"
            >
              {{
                extras1.textSetting.timeTitle == "custom"
                  ? extras1.textSetting.text3
                  : "会议时间"
              }}
            </div>
            <div
              class="_time"
              v-show="extras1.textSetting.time != 'hide'"
              :style="{
                color:
                  extras1.textSetting.time == 'custom'
                    ? extras1.textSetting.fontColor4
                    : '',
                background: extras1.textSetting.bgColor6 || '',
                'font-style':
                  extras1.textSetting.time == 'custom'
                    ? extras1.textSetting.fontTilt4 == 'on'
                      ? 'italic'
                      : 'normal'
                    : '',
                'font-Weight':
                  extras1.textSetting.time == 'custom'
                    ? extras1.textSetting.fontWeight4 == 'on'
                      ? 'bolder'
                      : ''
                    : '',
              }"
            >
              {{ handleTimeStamps(seminarInfo.startTime, seminarInfo.endTime) }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="seminar-info" v-if="isSetting == '1'">
      <div
        class="seminar-info-new"
        v-if="extras1 && extras1.seminarInfo.display == '1'"
      >
        <div class="content">
          <div class="seminar-title">2023企业数字化峰会</div>
          <div class="seminar-slogan">设计连接 新商业</div>
          <div class="semianr-time">
            <div class="_title">
              {{ "会议时间" }}
            </div>
            <div class="_time">
              {{ "2023.12.12-12.13" }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="field-area form1"
      :style="{
        background:
          extras1.formFieldBg.colorOrBg == 'color'
            ? extras1.formFieldBg.color
            : 'url(' + extras1.formFieldBg.src + ')',
      }"
    >
      <vue-scroll :ops="ops">
        <div
          class="title"
          :class="extras1.formTitle.textAlign"
          :style="{ 'letter-spacing': extras1.formTitle.wordWidth + 'px' }"
          v-if="extras1.formTitle.display == 1 && formInfo.status != 2"
        >
          {{ extras1.formTitle.title }}
        </div>
        <CField
          class="field-wrap new"
          :formData="formData"
          :platform="platform"
          v-if="formInfo.status != 2"
        />
        <div
          v-if="formInfo.status == 2"
          style="
            position: absolute;
            top: 50%;
            width: 100%;
            transform: translateY(-80%);
          "
        >
          <div class="u-success">
            <img :src="imgUrlObj[platform]['over']" alt="" />
          </div>
          <div class="split-line"></div>
          <div class="title">报名已截止！</div>
        </div>
        <div v-if="preview || formInfo.status == 1">
          <div class="split-line"></div>
          <div class="bottom">
            <a-button
              class="submit"
              type="primary"
              @click="submit()"
              :disabled="isSubmitting"
              :style="{
                width: extras.submitButton.width + '%',

                color:
                  extras.submitButton.buttonTextStyle == 'custom'
                    ? extras.submitButton.fontColor
                    : '',

                'font-style':
                  extras.submitButton.buttonTextStyle == 'custom'
                    ? extras.submitButton.fontTilt == 'on'
                      ? 'italic'
                      : 'normal'
                    : '',
                'font-weight':
                  extras.submitButton.buttonTextStyle == 'custom'
                    ? extras.submitButton.fontWeight == 'on'
                      ? 'bolder'
                      : ''
                    : '',
                'font-size':
                  extras.submitButton.buttonTextStyle == 'custom'
                    ? extras.submitButton.fontSize + 'px'
                    : '',
              }"
            >
              {{ extras | extra("submitButton.text") }}
            </a-button>
            <a-button
              class="btn-default"
              v-show="formInfo.identity == 1"
              v-if="extras.seminarButton && extras.seminarButton.display == 1"
              @click="togoVerifyNew()"
            >
              {{ extras | extra("seminarButton.text") }}
            </a-button>
          </div>
        </div>
      </vue-scroll>
    </div>
  </div>
</template>

<script>
//import Logo from "@/components/Logo.vue";
//import Banner from "@/components/Banner.vue";
import CField from "@/components/CField.vue";
//import FormStatus from "@/components/FormStatus.vue";
// import Meeting from "@/components/Meeting.vue";
import mixinConfig from "../../mixin/configNew.js";
import mixinMeeting from "../../mixin/meetingNew.js";
import mixin from "../../mixin/form.js";

export default {
  name: "PcIndex",
  mixins: [mixinConfig, mixinMeeting, mixin],
  components: {
    //    Logo,
    //    Banner,
    CField,
    //    FormStatus,
    //    Meeting,
  },

  data() {
    return {
      platform: "pc",
      ops: {
        rail: {
          opacity: "1",
          background: "#eeeeee",
          size: "6px",
        },
        bar: {
          size: "6px",
          background: "#cccccc",
          keepShow: true,
        },
      },
      imgUrlObj: {
        pc: {
          nostart: require("@/assets/images/pc/icon-no-start.png"),
          over: require("@/assets/images/pc/icon-over.png"),
        },
        wap: {
          nostart: require("@/assets/images/wap/icon-no-start.png"),
          over: require("@/assets/images/wap/icon-over.png"),
        },
      },
    };
  },

  mounted() {
    if (window == window.parent) {
      if (window.innerHeight < 837) {
        //如果可视区域小于弹窗的本身高度 需要按窗口高度比例缩小
        document
          .getElementById("app")
          .style.setProperty(
            "transform",
            "translateY(-50%) scale(" + (window.innerHeight / 837) * 0.97 + ")"
          );
        //        document.getElementById('app').style.setProperty('transform', 'translateY(-50%) scale(' + 1 / window.devicePixelRatio + ')');
      } else {
        document
          .getElementById("app")
          .style.setProperty("transform", "translateY(-50%)");
      }
      document.getElementById("app").style.setProperty("position", "relative");
      document.getElementById("app").style.setProperty("top", "50%");
    }
  },
  computed: {
    extras1() {
      if (window == window.parent) {
        document.body.style.setProperty(
          "background",
          (this.$store.state.extras.pageBg &&
            this.$store.state.extras.pageBg.color) ||
            "#FFFFFF"
        );
      }
      return this.$store.state.extras;
    },
  },
};
</script>
